import React from "react";
import {longColour, shortColour} from "../../style/styleConsts";

export const colourMapping = {
    SHORT: shortColour,
    LONG: longColour
};

export default function IdeaType(props) {
    const caseMapping = {
        SHORT: "Short",
        LONG: "Long"
    };
    return <div style={{fontWeight: "bold", color:colourMapping[props.type], ...props.style}}>{caseMapping[props.type]}</div>
}